import { TileLayer, BitmapLayer, GeoJsonLayer, COORDINATE_SYSTEM } from 'deck.gl';
import GL from '@luma.gl/constants';
import chroma from "chroma-js";

import { scaleLinear } from "d3-scale"

const heightScale = scaleLinear()
  .domain([0,1,2,3,4,5,6,7])
  .range([10000,5000,2500,1000,500, 100, 10])


export function renderLayers({ data, selectedValue }) {

  console.log("selectedValue", selectedValue)
 

  const point = new GeoJsonLayer({
    id: 'geojson-layer',
    coordinateSystem: (selectedValue === "on") ? COORDINATE_SYSTEM.LNGLAT_OFFSETS : COORDINATE_SYSTEM.LNGLAT,
    data:data,
    pickable: true,
    extruded: true,
    opacity: 1,
    stroked: true,
    filled: true,
    lineWidthMinPixels: 2,
    elevationScale:100,
    getFillColor: () => chroma.random().rgb(),
    getLineColor: d => [255, 255, 255],
    getElevation: (d, { index }) => {
      return heightScale(+d.properties.pwrIndxContainer); //500m * indexを高さに指定
    },
    onClick: (d) => {
      let power = 0;
      console.log(d.object.properties)
      console.log(heightScale(+d.object.properties.pwrIndxContainer))
    }
    /*
    getElevation:d=>{
      if (d.properties.pwrIndxContainer){
        const power = (7 - (+d.properties.pwrIndxContainer)) ^ 4 * 1000;
        console.log(power)
        return (7 - (+d.properties.pwrIndxContainer)) ^ 4 * 1000
      }
      return 1000
    }
    */
  });

  //OSMタイルを読み込みベースマップとして表示
  const tileLayer = new TileLayer({
    id:"tile-layer",
    data: "https://c.tile.openstreetmap.org/{z}/{x}/{y}.png",
    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,

    renderSubLayers: (props) => {
      const {
        bbox: { west, south, east, north }
      } = props.tile;

      return new BitmapLayer(props, {
        data: null,
        image: props.data,
        bounds: [west, south, east, north]
      });
    }
  });  

  //レイヤーの重なり順を配列で指定(先頭のレイヤーが一番下になる)
  return [ point];
}
